/**
 * @module Widget
 */

import {WidgetWindowBridge} from './WidgetWindowBridge'
import {WidgetRequest} from './WidgetRequest'
import {WidgetResponse} from './WidgetResponse'
import {WidgetFactories} from './WidgetFactories'

export {
  /**
   * @type {WidgetWindowBridge}
   */
  WidgetWindowBridge,

  /**
   * @type {WidgetRequest}
   */
  WidgetRequest,

  /**
   * @type {WidgetResponse}
   */
  WidgetResponse,

  /**
   * @type {WidgetFactories}
   */
  WidgetFactories
};




// WEBPACK FOOTER //
// ./src/main/javascript/Widget/index.js